/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Vu Dinh Luan (vdluan@rsupartners.com)
 *
 * @description
 *
 * @created at Mon Dec 18 2024
 **/

import { Typography, Row } from "@/frameworks/designStuff/components";
import { _P } from "@rfice/language";
import { usePersistUser } from "@/frameworks/core/persistence";

interface NameUpdateSystemChatProps {
	systemForm: ChatServices.Format2.System.NameUpdate;
}

const NameUpdateSystemChat = ({ systemForm }: NameUpdateSystemChatProps) => {
	const user = usePersistUser(systemForm.data.memberId);
	return (
		<Typography.div
			typoSize="Body2"
			style={{
				flexWrap: "wrap",
				fontWeight: "bold",
				borderRadius: "12px",
				padding: "8px 16px",
				backgroundColor: "transparent",
				margin: "4px 0"
			}}
		>
			<Row gap={10} verticalAlign="center">
				<Typography.div typoSize="Title2" style={{ wordBreak: "break-all" }}>
					{_P("{{member}} 님이 채널의 이름을 {{nameChannel}} 로 바꾸었습니다.", {
						member: `<span style="color: #7F86F3" data-user="${systemForm.data.memberId}">${user?.name}</span>`,
						nameChannel: `<span style="color: #7F86F3" data-user="${systemForm.data.roomName}">${systemForm.data.roomName}</span>`
					})}
				</Typography.div>
			</Row>
		</Typography.div>
	);
};

export default NameUpdateSystemChat;
